import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useHistory } from 'react-router-dom';
import AuditSettingsDetails from './AuditSettingsDetails';
import RouteKey from '../../routes/key';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';
import LoadingComponent from '../../components/LoadingComponent';

const { error } = RouteKey.child;
const { generic } = RouteKey.error.child;

const AuditSettings = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [hasView, setHasView] = useState<boolean>(false);

  const { data: userAuthoritiesData = [] } = useGetUserAuthorities();

  useEffect(() => {
    if (userAuthoritiesData.length) {
      if (!userAuthoritiesData.includes(AUTHORITY_NAMES.CP_ADMIN_AUDIT_SETTINGS_VIEW)) {
        history.push(`/${error}/${generic}`);
      } else {
        setHasView(true);
      }
    }
  }, [history, userAuthoritiesData]);

  return (
    <>
      <TitleHeader title={t('admin->>AuditSettings.AuditSettings')} />
      {hasView ? <AuditSettingsDetails /> : <LoadingComponent />}
    </>
  );
};

export default AuditSettings;
